/* eslint-disable complexity */
import { Box, CircleCheckMarkIcon, CircleRestrictedIcon, CircleXIcon, Flex, useLocalVariant } from "@draftkings/arena-web";
import { OpenMarkIcon } from "../../OpenMarkIcon";
import { getFunctionHandler, getVariantHandler, mapHandler } from "../../../../../constants";
import * as React from "react";
import { shouldDisplayBonusInelligibleBadge } from "../../../../../helpers";
import { SelectionCard } from "../../SelectionCard";
import { EventCard } from "../../EventCards";
import { LegTracking } from "../../LegTracking";
import { getSelectionCardVariant } from "./getSelectionCardVariant";
import { ProtectionIcon } from "../../ProtectionIcon";
const selectionSettlementStatusMap = new Proxy({
    Open: OpenMarkIcon,
    Won: CircleCheckMarkIcon,
    Lost: CircleXIcon,
    CashOut: CircleCheckMarkIcon,
    Cancelled: CircleRestrictedIcon,
    DeadHeatReduction: CircleCheckMarkIcon,
    Void: CircleRestrictedIcon,
}, getFunctionHandler);
const regularSelectionSettlementStatusVariantMap = new Proxy({
    Open: "regularOpenSelectionSettlementStatus",
    Won: "regularSelectionSettlementStatus",
    Lost: "regularSelectionSettlementStatus",
    CashOut: "regularSelectionSettlementStatus",
    Cancelled: "regularSelectionSettlementStatus",
    DeadHeatReduction: "regularSelectionSettlementStatus",
    Void: "regularSelectionSettlementStatus",
}, getVariantHandler);
const nestedSelectionSettlementStatusVariantMap = new Proxy({
    Open: "nestedOpenSelectionSettlementStatus",
    Won: "nestedSelectionSettlementStatus",
    Lost: "nestedSelectionSettlementStatus",
    CashOut: "nestedSelectionSettlementStatus",
    Cancelled: "nestedSelectionSettlementStatus",
    DeadHeatReduction: "nestedSelectionSettlementStatus",
    Void: "nestedSelectionSettlementStatus",
}, getVariantHandler);
const selectionSettlementStatusVariantMap = new Proxy({
    regular: regularSelectionSettlementStatusVariantMap,
    nested: nestedSelectionSettlementStatusVariantMap,
}, mapHandler);
export const SelectionsListItem = React.memo(function SelectionsListItem(props) {
    const { purchaseId, selection, event, playerBonus, index, selectionsLength, connected, children, } = props;
    const dottedLine = useLocalVariant("layout", {
        root: {
            flex: "1 1 auto",
            margin: "0 auto",
            width: "0",
            border: "0",
            borderStyle: "dashed",
            borderLeftWidth: "1px",
            borderLeftColor: "$gray600",
            backgroundColor: "transparent",
        }
    });
    const Status = selectionSettlementStatusMap[selection.status];
    const displayBoostInelligibleLabel = shouldDisplayBonusInelligibleBadge(playerBonus, selection);
    // eslint-disable-next-line complexity
    const isGhostLeg = (playerBonus === null || playerBonus === void 0 ? void 0 : playerBonus.type) === "GUARANTEED_PAYOUT" && playerBonus.boostStatus === "GuaranteedPayoutWon" && selection.status === "Lost";
    return React.createElement(Flex, { position: "relative", key: selection.selectionId, testId: 'selection-list-item' },
        React.createElement(Flex, { flexDirection: "column", marginRight: "12px" },
            selection.status === "EarlyExit" ? React.createElement(ProtectionIcon, { isNested: selection.type === "nested" }) : React.createElement(Status, { variant: selectionSettlementStatusVariantMap[selection.type][selection.status], maxWidth: "none", maxHeight: "none" }),
            index + 1 < selectionsLength
                && connected
                && React.createElement(Box, { variant: `layout.${dottedLine}` })),
        React.createElement(SelectionCard, Object.assign({ purchaseId: purchaseId }, selection, { displayBoostInelligibleLabel: displayBoostInelligibleLabel, selectionCardVariant: getSelectionCardVariant(index === selectionsLength - 1, !selection.legTracking), isGhostLeg: isGhostLeg }),
            children,
            selection.legTracking &&
                React.createElement(LegTracking, Object.assign({}, selection.legTracking)),
            event && React.createElement(EventCard, { status: selection.status, event: event })));
});
//# sourceMappingURL=SelectionsListItem.js.map